/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

export type OptionsFieldsParamParameterItem =
  (typeof OptionsFieldsParamParameterItem)[keyof typeof OptionsFieldsParamParameterItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OptionsFieldsParamParameterItem = {
  accounting_type: 'accounting_type',
  organization: 'organization',
  expenditure_purpose: 'expenditure_purpose',
  expenditure_nature: 'expenditure_nature',
  expenditure_settlement_purpose: 'expenditure_settlement_purpose',
  expenditure_settlement_nature: 'expenditure_settlement_nature',
  expenditure_project: 'expenditure_project',
  expenditure_project_category: 'expenditure_project_category',
  revenue_nature: 'revenue_nature',
  revenue_settlement_purpose: 'revenue_settlement_purpose',
} as const;
